import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cn } from '@/utils/cn';
import useBodyOverflow from '@/app/hooks/useBodyOverflow';
import Button from '@/app/components/Button';
import Icon from '@/app/components/Icon';
import Text from '@/app/components/Text';
import { goBackToMenu } from '@/redux/reducers/hamburger-menu-reducer';
import SubMenuCard from './SubMenuCard';

function SubMenuSections({ selectedMenu }) {
  const dispatch = useDispatch();
  const { isSubMenuOpen } = useSelector((state) => state.hamburgerMenu);
  const { items: categories, brands } = useSelector(
    (state) => state.categories,
  );

  // hooks
  useBodyOverflow(!!selectedMenu);

  const [activeSubMenuId, setActiveSubMenuId] = useState(null);

  const handleToggleSubMenuItems = (subMenu) => {
    setActiveSubMenuId((prev) => (prev === subMenu.id ? null : subMenu.id));
  };

  return (
    <div
      className={cn(
        'flex lg:hidden bg-white p-16 fixed z-[1000] w-full left-0 top-0 pb-[100px] h-full',
        {
          'overflow-y-auto': isSubMenuOpen,
        },
      )}
    >
      <div className=" w-full">
        <Button
          type="link"
          className="flex items-center gap-[8px] !p-0 mb-16"
          onClick={() => dispatch(goBackToMenu())}
        >
          <Icon type="arrow-left" className="size-[20px]" color="#49525E" />
          <Text type="paragraph" className="text-sm text-senate font-semibold">
            Go back
          </Text>
        </Button>

        <div className="w-full sub-menu-sections">
          <Text type="navigation_title" className="mb-8">
            {selectedMenu.label}
          </Text>

          {selectedMenu.label === 'Product Categories' &&
            categories?.length > 0 &&
            categories?.map((subCategory) => (
              <SubMenuCard
                type={selectedMenu.id}
                key={subCategory.id}
                subMenu={subCategory}
                onToggleSubMenuItems={handleToggleSubMenuItems}
                activeSubMenuId={activeSubMenuId}
              />
            ))}

          {selectedMenu.label === 'Brands' &&
            brands?.top?.length > 0 &&
            brands?.top?.map((subCategory) => (
              <SubMenuCard
                type="brands"
                isTopBrand
                key={subCategory.id}
                subMenu={subCategory}
                onToggleSubMenuItems={handleToggleSubMenuItems}
                activeSubMenuId={activeSubMenuId}
              />
            ))}

          {selectedMenu.label === 'Brands' &&
            brands?.others?.length > 0 &&
            brands?.others?.map((subCategory) => (
              <SubMenuCard
                type="brands"
                isTopBrand={false}
                key={subCategory.id}
                subMenu={subCategory}
                onToggleSubMenuItems={handleToggleSubMenuItems}
                activeSubMenuId={activeSubMenuId}
              />
            ))}

          {selectedMenu.label !== 'Product Categories' &&
            selectedMenu.label !== 'Brands' &&
            selectedMenu?.subMenu?.map((subMenu) => (
              <SubMenuCard
                type={selectedMenu.id}
                key={selectedMenu.id}
                subMenu={subMenu}
                onToggleSubMenuItems={handleToggleSubMenuItems}
                activeSubMenuId={activeSubMenuId}
                isStaticIcon
              />
            ))}
        </div>
      </div>
    </div>
  );
}

export default SubMenuSections;
